import { requestService } from 'shared/utils/services/requestService';

export const getBrandFollowRequest = async (brandId: string) => {
  return requestService({
    url: `/web-api/follow/get-follow?brandId=${brandId}`,
    method: 'GET',
  });
};

export const submitBrandFollowRequest = async (brandId: string) => {
  return requestService({
    url: `/web-api/follow/brand-follow`,
    method: 'POST',
    data: JSON.stringify({
      brandId,
    }),
  });
};

export const submitBrandUnFollowRequest = async (brandId: string) => {
  return requestService({
    url: `/web-api/follow/brand-unfollow`,
    method: 'POST',
    data: JSON.stringify({
      brandId,
    }),
  });
};
